import { IPromoBannerViewProps } from '@msdyn365-commerce-modules/promo-banner';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { USER_ROLE } from '../../../configuration/user-roles';
import { IUserRoleState } from '../../../states/user-role-state';
import { IPromoBannerConfig } from '../definition-extensions/promo-banner.ext.props.autogenerated';

interface IExtendedPromoBannerData {
    userRoleState: AsyncResult<IUserRoleState>;
}

interface IExtendedPromoBannerViewProps extends IPromoBannerViewProps {
    config: IPromoBannerConfig;
    data: IExtendedPromoBannerData;
}

const PromoBannerView: React.FC<IExtendedPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        promoBannerTextProps,
        promoBannerLinksProps,
        carouselProps,
        promoBannerText,
        config,
        handleLinks,
        handleText
    } = props;

    const demoMessages = config?.demoMessages;
    const userRoles = props.data?.userRoleState?.result?.userRoles || [];
    const hasAllowedRole = userRoles.includes(USER_ROLE.DEMO);
    const hasDemoMessages = !!demoMessages && demoMessages.length > 0;
    const messagesToRender = hasAllowedRole && hasDemoMessages ? demoMessages : bannerMessages;

    const slides =
        messagesToRender &&
        messagesToRender.map((message, index) => {
            return (
                <Node {...contentProps} key={index} aria-live='off' role='marquee'>
                    <span className='sr-only'>{promoBannerText}</span>
                    {message.text && <Node {...promoBannerTextProps} text={message.text} onClick={handleText} />}
                    {message.links && message.links.length > 0 && (
                        <Node {...promoBannerLinksProps} links={message.links} onClick={handleLinks} />
                    )}
                </Node>
            );
        });

    return (
        <Module {...promoBannerProps}>
            <Node {...carouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
